import { render, staticRenderFns } from "./DisclosurePage.vue?vue&type=template&id=593048f6&"
import script from "./DisclosurePage.vue?vue&type=script&lang=js&"
export * from "./DisclosurePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports